import axios from "axios";

export default {
  state: {
    user: null,
    isLoadingAuthUser: false,
  },
  actions: {
    getAuthUser({commit, state}) {
      state.isLoadingAuthUser = true;
      return axios.get(`/api/v1/me`)
        .then(r => {
          commit("SET_AUTH_USER", r.data.data);
          return r;
        })
        .finally(() => {
          state.isLoadingAuthUser = false;
        });
    },
    logout({commit}){
      axios.get(`/api/v1/logout`)
        .then(() => {
          commit("SET_AUTH_USER", null);
        })
    }
  },
  mutations: {
    SET_AUTH_USER(state, payload) {
      state.user = payload;
    },
    SET_LAST_ACCESS_MODULE(state, payload){
      state.user.last_accessed_module_on_current_cycle = payload;
    }
  },
  getters: {
    authUser: state => state.user,
    hasSchedule: state => state.user.has_schedule,
    hasTrail: (state) =>  !!state.user?.current_trail,
    lastModule: (state) => state.user.last_accessed_module_on_current_cycle,
    lastModuleIsFinished: (state, getters) => getters.hasLastModule && getters.lastModule?.finished_at,
    lastModuleIsUnfinished: (state, getters) => !!getters.lastModule?.finished_at,
    hasLastModule: (state) => !!state.user.last_accessed_module_on_current_cycle,
    currentTrail: (state) => state.user.current_trail,
    lastRecommendedModules: state => state.user.last_recomended_module,
    lastRecommendedModule : (state, getters) => getters.lastRecommendedModules[0],
    lastRecommendedModuleId : (state, getters) => getters.lastRecommendedModule ? getters.lastRecommendedModule.id :  null,
    lastUnfinishedRecommendedModules: (state, getters) => getters.lastRecommendedModules.filter(m=> !m.finished_at),
    hasLastUnfinishedRecommendedModules: (state, getters) => getters.lastUnfinishedRecommendedModules.filter(m=> !m.finished_at).length > 0,
    lastUnfinishedRecommendedModule: (state, getters) => getters.hasLastUnfinishedRecommendedModules ? getters.lastUnfinishedRecommendedModules[0] : null,
    report_logs : state => state.user.report_logs,
  }
};
